// src/pages/matching-intergenerationnel/DemoHeirEntry.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDemoPage } from "@/lib/useDemoPage";
import { deriveArchetype } from "../../lib/matchingArchetypes";

// Profil de démo construit à partir des vraies dimensions en base pour Antoine
// Rousseau (compte demo.famille.succession@artkiv-demo.com). Sert de point
// d'entrée fiable pour la démo galeriste : contourne le lien d'accès héritier
// et l'endpoint /api/heirs/me, qui dépendent d'une vraie session.
const DEMO_DIMS = {
  heritage: 46,
  innovation: 97,
  plaisir: 100,
  esthetique: 100,
  conceptuel: 52,
  emotionnel: 100,
  social: 37,
  individuel: 100,
  investissement: 43,
};

const DEMO_HEIR_PROFILE = {
  name: "Antoine Rousseau",
  job: "Architecte d'intérieur",
  city: "Lyon",
  age: 26,
  situation: "En couple",
  domaine: "Architecture / Design",
  dims: DEMO_DIMS,
  archetype: deriveArchetype(DEMO_DIMS),
  axes: {
    ouverture: DEMO_DIMS.innovation,
    esthetique: DEMO_DIMS.esthetique,
    experience: Math.round((DEMO_DIMS.emotionnel + DEMO_DIMS.conceptuel + DEMO_DIMS.plaisir) / 3),
    collectif: DEMO_DIMS.social,
    rapport_au_temps: "present",
  },
  artKeywords: ["modernité", "abstraction", "couleur"],
  artMessage:
    "Je veux garder un lien avec ce que mes parents ont transmis, tout en y apportant mon regard.",
};

export default function DemoHeirEntry() {
  const navigate = useNavigate();
  const trackCta = useDemoPage("notaire-heritier");

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 text-center">
      <h1 className="text-2xl font-bold mb-2">Démo — Profil héritier</h1>
      <p className="text-gray-600 mb-6 max-w-md">
        Point d'entrée de démonstration : ouvre directement les recommandations
        pour Antoine Rousseau, sans passer par un lien d'accès réel.
      </p>
      <button
        onClick={() => {
          trackCta("voir_profil_heritier");
          navigate("/matching/scoring", { state: { heirProfile: DEMO_HEIR_PROFILE } });
        }}
        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
      >
        Voir le profil d'Antoine Rousseau
      </button>
      <button
        onClick={() => {
          trackCta("vue_etude_notaire");
          navigate("/notaire");
        }}
        className="mt-4 text-sm text-gray-600 underline hover:text-gray-900"
      >
        Étape suivante : voir la vue de l'étude (compte notaire)
      </button>
    </div>
  );
}
